import BasicLayout from "@/layouts/basic-layout";

const meta = {
  auth: false,
  cache: false,
};
export default {
  path: "/statement",
  name: "statement",
  redirect: {
    name: "statement",
  },
  meta,
  component: BasicLayout,
  children: [
    {
      path: "departmentReport",
      name: "departmentReport",
      meta: {
        title: "部门报表",
      },
      component: () => import("@/pages/statement/departmentReport/index.vue"),
    },
    {
      path: "personalReport",
      name: "personalReport",
      meta: {
        title: "个人报表",
      },
      component: () => import("@/pages/statement/personalReport/index.vue"),
    },
    {
      path: "weeklyReport",
      name: "weeklyReport",
      meta: {
        title: "工作专报",
      },
      component: () => import("@/pages/statement/weeklyReport/index.vue"),
    },
  ],
};
